import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid lg:grid-cols-[80px_auto_auto_50px] grid-cols-[80px_auto_50px] gap-x-5" }
const _hoisted_2 = { class: "profile-img row-span-2" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "h3" }
const _hoisted_5 = { class: "h3 text-right leading-[52px] hidden lg:block" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-reply h1 leading-[80px] row-span-2 font-gradient-cta text-center overflow-visible",
  role: "button"
}, null, -1)
const _hoisted_7 = { class: "uppercase" }
const _hoisted_8 = { class: "text-right hidden uppercase lg:block" }
const _hoisted_9 = { class: "mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["mt-10 text-left", _ctx.nested ? 'ml-12' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", { src: _ctx.profilepic }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.name), 1),
      _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.role), 1),
      _hoisted_6,
      _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.area), 1),
      _createElementVNode("time", _hoisted_8, _toDisplayString(_ctx.time), 1)
    ]),
    _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.message), 1)
  ], 2))
}